import { HistoryRoutePathnames } from '@user/store/lead'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function useBrowserHistory() {
  const location = useLocation()
  const prevLocationRef = useRef(location)

  useEffect(() => {
    // Track navigation changes
    if (prevLocationRef.current !== location) {
      const currentPathname = sessionStorage.getItem('currentPathname')
      sessionStorage.setItem('previousPathname', currentPathname ?? '')
      sessionStorage.setItem('currentPathname', window.location.href)
      prevLocationRef.current = location
    }

    const handleUnload = () => {
      if (
        !window.location.href.includes(HistoryRoutePathnames.DRAFT_LEAD_ADD) ||
        !window.location.href.includes(HistoryRoutePathnames.LEAD_DETAILS) ||
        !window.location.href.includes(
          HistoryRoutePathnames.OPPORTUNITY_DETAILS,
        )
      ) {
        const currentPathname = sessionStorage.getItem('currentPathname')
        sessionStorage.setItem('previousPathname', currentPathname ?? '')
        sessionStorage.setItem('currentPathname', window.location.href)
      }
    }
    window.addEventListener('unload', handleUnload)

    return () => {
      window.removeEventListener('unload', handleUnload)
    }
  }, [location])
}
